import { useSelection } from '@cube3/state/src/redux/components/useSelection';
import React, { useCallback, useEffect, useState } from 'react';
import { useReviewNodeTree } from '../../ReviewTool/Hooks/useReviewNodeTree';
import { useResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResource';
import { AssetTileSmart } from '../../ReviewTool/SubComponents/AssetTileSmart';
import { useRenderFolders } from '../../ReviewTool/Hooks/useRenderFolders';
import { useGenerativeContext } from '../contexts/GenerativeContext';
import { NodeTree } from '@cube3/cubicle/src/core/organisms/NodeTree';
import { useIntersectionObserver } from '@cube3/cubicle/src/core/atoms/Scrollbar/hooks/useIntersectionObserver';
import { AssetTile } from '@cube3/cubicle/src/core/molecules/ReviewTools/AssetTile';
import { Asset } from '@cube3/common/model/schema/resources/asset';

export const FolderContent = () => {
  const { visiting, selection: preSelection } = useSelection();

  const rootNodeId = visiting && visiting['relationships']['node']['id'];

  const nodeTree = rootNodeId ? useReviewNodeTree(rootNodeId, -1, true) : null;

  const { resource: rootNode } = useResource__ALPHA({
    resourceId: rootNodeId,
    resourceType: 'content-tree-node',
    strategy: 'fetch-on-mount'
  });

  const fileType =
    rootNode?.relationships.resource.type === 'asset' ? 'asset' : 'folder';

  const asset = useResource__ALPHA({
    resourceId: fileType === 'asset' ? rootNodeId : undefined,
    resourceType: fileType === 'asset' ? 'asset' : undefined
  });

  const renderFoldersProps = useRenderFolders(nodeTree);
  const { selections, isAssetSelected, setSelections } = useGenerativeContext();

  const renderAssetTile = useCallback(
    (a: Asset) => <AssetListItem asset={a} isActive={isAssetSelected(a)} />,
    [selections]
  );

  useEffect(() => {
    if (preSelection?.length) {
      setSelections(preSelection);
    }
  }, [preSelection]);

  return (
    <>
      {fileType === 'folder' && (
        <NodeTree
          {...renderFoldersProps}
          rootNode={rootNodeId}
          parentId={rootNodeId}
          activeAsset={selections[selections.length - 1]}
          renderAssetTile={renderAssetTile}
        />
      )}
      {fileType === 'asset' ? (
        <AssetTileSmart key={rootNodeId} asset={asset.resource} />
      ) : null}
    </>
  );
};

const AssetListItem = ({ asset, isActive = false }) => {
  const [ref, setRef] = useState<HTMLElement>(null);
  const visible = useIntersectionObserver(ref);
  const { setSelections, canSelectMore } = useGenerativeContext();

  const onClick = useCallback(() => {
    setSelections(asset);
  }, [setSelections]);

  return (
    <AssetTile
      ref={setRef}
      type="asset"
      resource={visible ? asset : undefined}
      onClick={onClick}
      active={isActive}
      showStatus={false}
      withCheckbox={true}
      checkboxDisabled={!isActive && !canSelectMore}
    />
  );
};
